import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1.5rem 1.375rem 1.5rem;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: flex-end;

  & .hefesto-input-wrapper {
    max-width: 42rem;
    margin-right: 0.25rem;
  }

  & > button {
    min-width: 9rem;
    margin-bottom: 0.285rem;
  }
`;
